<script lang="ts">
	import type { Page } from '$lib/graphql/strapiApi';
	import Pricing from '$lib/components/pricing.svelte';
	import EndActions from '$lib/components/end-actions.svelte';
	import Hero from '$lib/components/hero.svelte';
	import Heading from '$lib/components/heading.svelte';
	import Features from '$lib/components/features.svelte';
	import FeatureRows from '$lib/components/featureRows.svelte';
	import FeatureColumns from '$lib/components/featureColumns.svelte';
	import Integrations from '$lib/components/integrations.svelte';
	import Partners from '$lib/components/partners.svelte';
	import RedGreen from '$lib/components/red-green.svelte';
	import Questions from '$lib/components/questions.svelte';
	import Steps from '$lib/components/steps.svelte';
	import BottomActions from '$lib/components/bottom-actions.svelte';
	import Table from '$lib/components/table.svelte';
	import { replaceImg } from '$lib/utils.js';

	let { page }: { page: Page } = $props();
	let contents = $derived(page.contentSections?.filter((x) => x !== null) ?? []);
	let lastContent = $derived(contents[contents.length - 1]);
	let hasBottomActions = $derived(lastContent?.__typename === 'ComponentSectionsBottomActions');
</script>

<div class="flex w-full justify-center">
	<div
		class="flex w-full max-w-screen-xl flex-col justify-center gap-y-32 pt-6 max-sm:px-3 sm:px-8"
	>
		{#each contents as content, index}
			{#if content.__typename === 'ComponentSectionsHero'}
				<Hero {content} />
			{:else if content.__typename === 'ComponentSectionsHeading'}
				<Heading {content} />
			{:else if content.__typename === 'ComponentSectionsPartners'}
				<Partners {content} />
			{:else if content.__typename === 'ComponentSectionsRedGreen'}
				<RedGreen {content} />
			{:else if content.__typename === 'ComponentSectionsQuestions'}
				<Questions {content} />
			{:else if content.__typename === 'ComponentSectionsIntegrations'}
				<Integrations {content} />
			{:else if content.__typename === 'ComponentSectionsFeatureColumnsGroup'}
				<FeatureColumns
					title={content.title}
					description={content.description}
					features={content.features?.filter((x) => x !== null) ?? []}
				/>
			{:else if content.__typename === 'ComponentSectionsFeatureRowsGroup'}
				<FeatureRows features={content.features?.filter((x) => x !== null) ?? []} />
			{:else if content.__typename === 'ComponentSectionsFeatures'}
				<Features
					heading={content.heading}
					description={content.description}
					features={content.feature?.filter((x) => x !== null) ?? []}
				/>
			{:else if content.__typename === 'ComponentSectionsRichText'}
				<div class="prose {index === 0 ? 'mt-8' : ''}">
					{@html replaceImg(content.content, 'xlarge')}
				</div>
			{:else if content.__typename === 'ComponentSectionsPricing'}
				<Pricing {content} />
			{:else if content.__typename === 'ComponentSectionsSteps'}
				<Steps {content} />
			{:else if content.__typename === 'ComponentSectionsTable'}
				<Table {content} />
			{:else if content.__typename === 'ComponentSectionsBottomActions'}
				<BottomActions {content} />
			{/if}
		{/each}
		{#if !hasBottomActions}
			<EndActions />
		{/if}
	</div>
</div>
